import * as Matter from 'matter-js';
import * as Tone from 'tone';

let animationId = null;

const noteSets = {
  8: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4'],
  9: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4'],
  10: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4'],
  11: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4'],
  12: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4', 'C#4'],
  13: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4', 'C#4', 'C4'],
  14: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4', 'C#4', 'C4', 'B3'],
  15: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4', 'C#4', 'C4', 'B3', 'A#3'],
  16: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4', 'C#4', 'C4', 'B3', 'A#3', 'A3'],
};

class Note {
  constructor(note) {
    this.synth = new Tone.PolySynth().toDestination();
    this.synth.set({ volume: -6 });
    this.note = note;
  }

  play() {
    return this.synth.triggerAttackRelease(
      this.note,
      '32n',
      Tone.context.currentTime
    );
  }
}

let balls = 10;
const ballsEl = document.getElementById('balls');

let notes = noteSets[8].map((note) => new Note(note));

let GAP = 32;
let PEG_RAD = 8;
let pegs = [];
let pegAnims = [];
const width = 620;
const height = 525;

const pegSettings = {
  8: { GAP: 63, PEG_RAD: 7, BALL_RAD: 17, length: 90 },
  9: { GAP: 56, PEG_RAD: 7, BALL_RAD: 17, length: 110 },
  10: { GAP: 51, PEG_RAD: 7, BALL_RAD: 16, length: 120 },
  11: { GAP: 46, PEG_RAD: 7, BALL_RAD: 14, length: 135 },
  12: { GAP: 42, PEG_RAD: 6, BALL_RAD: 12, length: 150 },
  13: { GAP: 39, PEG_RAD: 6, BALL_RAD: 11, length: 150 },
  14: { GAP: 37, PEG_RAD: 5, BALL_RAD: 10, length: 170 },
  15: { GAP: 34, PEG_RAD: 4, BALL_RAD: 10, length: 180 },
  16: { GAP: 32, PEG_RAD: 3, BALL_RAD: 10, length: 180 },
};

function createPegs(numRows) {
  const settings = pegSettings[numRows] || { GAP: 30, PEG_RAD: 3, BALL_RAD: 6 };
  GAP = settings.GAP;
  PEG_RAD = settings.PEG_RAD;
  BALL_RAD = settings.BALL_RAD; // 👈 Update ball size

  if (pegs.length > 0) {
    // Composite.remove(engine.world, pegs);
    pegs.forEach(peg => Composite.remove(engine.world, peg));
    pegs = [];
    pegAnims = [];
  }

  for (let r = 0; r < numRows; r++) {
    const pegsInRow = r + 3;
    for (let c = 0; c < pegsInRow; c++) {
      const x = width / 2 + (c - (pegsInRow - 1) / 2) * GAP;
      const y = GAP + r * GAP;
      const peg = Bodies.circle(x, y, PEG_RAD, {
        isStatic: true,
        label: 'Peg',
        render: { fillStyle: '#fff' },
      });
      pegs.push(peg);
      pegAnims.push(null);
    }
  }

  Composite.add(engine.world, pegs);
}

function updateMultipliers(multipliers) {
  // console.log(multipliers); return
  multipliers.forEach((m, i) => {
    const el = document.getElementById(`note-${i}`);
    if (el) el.innerHTML = m >= 1000 ? '1k' : (m > 99 && m < 1000) ? m : m + 'x';
  });
  for (let i = 0; i < 17; i++) {
    const el = document.getElementById(`note-${i}`);
    if (el) el.style.display = i < multipliers.length ? 'block' : 'none';
  }
}

function createTriangleFunnels(numRows) {

  const wallThickness = 10;
  const triangleTopY = 80;
  const triangleHeight = height - 30;
  const triangleWidth = width - 120;
  const triangleStartX = 125;
  const triangleEndX = width / 2.5 + triangleWidth / 2;
  const slope = triangleHeight / (triangleWidth / 2);
  const angle = Math.atan(slope);
  const extraLength = pegSettings[numRows]['length'];

  const leftWall = Bodies.rectangle(
    triangleStartX - wallThickness / 2,
    triangleTopY + triangleHeight / 2,
    triangleHeight + extraLength,
    wallThickness,
    {
      isStatic: true,
      angle: -angle,
      render: { fillStyle: "transparent" }
    }
  );

  const rightWall = Bodies.rectangle(
    triangleEndX + wallThickness / 2,
    triangleTopY + triangleHeight / 2,
    triangleHeight + extraLength,
    wallThickness,
    {
      isStatic: true,
      angle: angle,
      render: { fillStyle: "transparent" }
    }
  );

  Matter.Composite.add(engine.world, [leftWall, rightWall]);
}



function resetWorld() {
  Composite.clear(engine.world, false);
  Matter.Events.off(engine, 'collisionStart');
  pegs = [];
  pegAnims = [];
  if (animationId) {
    cancelAnimationFrame(animationId);
    animationId = null;
  }
}

export function drawPlinko(numRows, multipliers) {
  resetWorld();
  createTriangleFunnels(numRows);
  // Ground
  const ground = Bodies.rectangle(width / 2, height + 22, width * 2, 40, {
    isStatic: true,
    label: 'Ground',
  });
  Composite.add(engine.world, [ground]);

  notes = noteSets[numRows].map((note) => new Note(note));
  updateMultipliers(multipliers);
  createPegs(numRows);

  const notesContainer = document.querySelector('.notes');
  if (notesContainer) {
    notesContainer.className = `notes row-${numRows}`;
  }


  // Collision handling
  Matter.Events.on(engine, 'collisionStart', (event) => {

    checkCollision(event, 'Ball', 'Ground', (ballToRemove) => {
      Matter.Composite.remove(engine.world, ballToRemove);
      const index = Math.floor((ballToRemove.position.x - width / 2) / GAP + multipliers.length / 2);
      //console.log(index, multipliers)
      if (index >= 0 && index < multipliers.length) {
        const ballsWon = Math.floor(multipliers[index]);
        //console.log(ballsWon)
        balls += ballsWon;
        const el = document.getElementById(`note-${index}`);
        //  console.log(el)
        if (el && el.dataset.pressed !== 'true') {
          const note = notes[index];
          note.play();
          console.log(note);
          el.dataset.pressed = 'true';
          el.dataset.value = multipliers[index];
          // console.log(multipliers[index])
          setTimeout(() => {
            el.dataset.pressed = 'false';
            el.dataset.value = "";
          }, 500);
        }
      }
    });

    checkCollision(event, 'Peg', 'Ball', (pegToAnimate) => {
      if (!pegToAnimate || !pegToAnimate.id) return;

      const index = pegs.findIndex((peg) => peg === pegToAnimate);
      if (index === -1) return
      //   {
      //   throw new Error('Could not find peg in pegs array');
      // }
      if (!pegAnims[index]) {
        pegAnims[index] = new Date().getTime();
      }
    });

  });

  // Renderer loop
  const canvas = document.getElementById('canvas');
  const render = Render.create({
    canvas,
    engine,
    options: {
      width,
      height,
      wireframes: false,
    },
  });
  Render.run(render);
  const ctx = canvas?.getContext('2d');

  function run() {
    // if (animationId) {
    //   cancelAnimationFrame(animationId);
    // }
    const now = new Date().getTime();
    pegAnims.forEach((anim, index) => {
      if (!anim) return;
      const delta = now - anim;
      if (delta > 1200) {
        pegAnims[index] = null;
        return;
      }
      const peg = pegs[index];
      if (!peg) throw new Error('Unknown peg at index ' + index);
      const pct = delta / 1200;
      const expandProgression = 1 - Math.abs(pct * 2 - 1);
      const expandRadius = expandProgression * 15;
      ctx.fillStyle = '#fff2';
      ctx.beginPath();
      ctx.arc(peg.position.x, peg.position.y, expandRadius, 0, 2 * Math.PI);
      ctx.fill();
    });
    Engine.update(engine, 1000 / 60);
    if (ballsEl) {
      ballsEl.innerHTML = balls;
    }
    animationId = requestAnimationFrame(run);
  }

  run();

  /******************qwertyuwertyui****************/
  // }, 200);
}

const clickSynth = new Tone.NoiseSynth({ volume: -26 }).toDestination();
// Matter.js setup
const Engine = Matter.Engine,
  Events = Matter.Events,
  Render = Matter.Render,
  Runner = Matter.Runner,
  Bodies = Matter.Bodies,
  Composite = Matter.Composite;

const engine = Engine.create({
  gravity: {
    scale: 0.0007,
  },
});

export function fallBall() {
  dropABall();
}


// Drop a ball
let BALL_RAD = 12;
function dropABall() {
  if (balls > 0) {
    balls -= 1;
    if (ballsEl) {
      ballsEl.innerHTML = balls;
    }
  } else {
    return;
  }
  const dropLeft = width / 2 - GAP;
  const dropRight = width / 2 + GAP;
  const dropWidth = dropRight - dropLeft;
  let rand = Math.random() * (0.8 - 0.3) + 0.3;

  const x = rand * dropWidth + dropLeft;

  const y = -PEG_RAD;
  const ball = Matter.Bodies.circle(x, y, BALL_RAD, {
    label: 'Ball',
    restitution: 0.6,
    render: {
      sprite: {
        texture:
          'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 13 12" fill="none"%3E%3Cellipse cx="6.5" cy="6" rx="5.91387" ry="5.91387" transform="rotate(-0.84069 6.5 6)" fill="url(%23paint0_radial_2657_4362)"/%3E%3Cellipse cx="6.50521" cy="6.05247" rx="4.30271" ry="4.30271" transform="rotate(-0.84069 6.50521 6.05247)" fill="url(%23paint1_radial_2657_4362)"/%3E%3Cpath d="M10.4075 5.99521C10.4391 8.15039 8.71765 9.92314 6.56247 9.95476C4.4073 9.98639 2.63454 8.26491 2.60292 6.10973C2.57129 3.95456 4.29277 2.18181 6.44795 2.15018C8.60312 2.11856 10.3759 3.84003 10.4075 5.99521Z" stroke="%2316171B" stroke-opacity="0.35" stroke-width="0.8"/%3E%3Cdefs%3E%3CradialGradient id="paint0_radial_2657_4362" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(6.5 6) rotate(90) scale(5.91387)"%3E%3Cstop stop-color="%23FFE2C8"/%3E%3Cstop offset="0.9999" stop-color="%23FF912C"/%3E%3C/radialGradient%3E%3CradialGradient id="paint1_radial_2657_4362" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(6.50521 6.05247) rotate(90) scale(4.30271)"%3E%3Cstop stop-color="%23FFE2C8"/%3E%3Cstop offset="0.9999" stop-color="%23FF912C"/%3E%3C/radialGradient%3E%3C/defs%3E%3C/svg%3E',
        xScale: BALL_RAD * 2 / 18, // since the SVG width is 18
        yScale: BALL_RAD * 2 / 18, // match height too
      },
      // fillStyle: '#FF912C',
      // strokeStyle:'#FFE2C8',
      // lineWidth: 8,
    },
  });
  clickSynth.triggerAttackRelease('32n', Tone.context.currentTime===0 ? 0.5 : Tone.context.currentTime);
  Matter.Composite.add(engine.world, [ball]);
}

function checkCollision(event, label1, label2, callback) {
  event.pairs.forEach(({ bodyA, bodyB }) => {
    let body1, body2;
    if (bodyA.label === label1 && bodyB.label === label2) {
      body1 = bodyA;
      body2 = bodyB;
    } else if (bodyA.label === label2 && bodyB.label === label1) {
      body1 = bodyB;
      body2 = bodyA;
    }
    if (body1 && body2) {
      callback(body1, body2);
    }
  });
}